<template>
  <div class="item2">
    <div class="name-price">
      <!-- {{item.plan_name}} -->
      <!-- <div class="name"></div> -->
      <div class="name flex-c">水杯编号: {{item.plan_name}}</div>
      <div class="price wechatNumber">+{{item.money}}</div>
    </div>
    <div class="date">{{item.create_time}}</div>
  </div>
</template>

<script>
  export default {
    props: {
      item: {
        type: Object,
        default: () => ({})
      }
    }
  }
</script>

<style lang="less" scoped>
  .item2 {
    .bg(#fff);
    .br(.1rem);
    .p(.28rem);
    .mb(.24rem);
    .name-price {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .mb(.28rem);
      .name {
        .fz(.28rem);
        .c(#333);
        // font-weight: bold;
      }
      .price {
        .fz(.34rem);
        .c(#ff2c4c);
      }
    }
    .date {
      .fz(.24rem);
      .c(#999);
    }
  }
</style>
